import { FormatFunction } from 'i18next';
import { NewspaperAttribute } from '../NewspaperAttribute';
import { capitalizeFirstLetter, capitalizeFirstLetterSp } from './capitalizeFirstLetter';

// declensionとcapを処理するフォーマット関数
export const grammarFormat: FormatFunction = (value, format) => {
  if (value instanceof Object && format?.startsWith('gram:')) {
    const item = value as NewspaperAttribute;
    const [, commandPart] = format.split(':');
    const commands = commandPart.split('|');

    // 格変化(declension)が必要な場合には変化済みのテキストを取得する
    let v = getValueWithDeclension(item, commands);

    // キャピタライズ処理
    if (commands.includes('cap')) {
      v = capitalizeFirstLetter(v);
    }
    if (commands.includes('cap_sp')) {
      v = capitalizeFirstLetterSp(v);
    }
    return v;
  }
  return value;
};

function getValueWithDeclension(attr: NewspaperAttribute, commands: string[]) {
  if (attr.type !== 'player' && attr.type !== 'npc' && attr.type !== 'item') {
    return attr.value as string;
  }

  if (!attr.grammar) {
    return attr.value;
  }
  if (commands.includes('declension_a') && attr.grammar?.CaseA) {
    return attr.grammar.CaseA;
  } else if (commands.includes('declension_d') && attr.grammar?.CaseD) {
    return attr.grammar.CaseD;
  } else if (commands.includes('declension_g') && attr.grammar?.CaseG) {
    return attr.grammar.CaseG;
  } else {
    return attr.value;
  }
}
